import React from 'react';
import { OutsideWrapper } from './components/OutsideWrapper/OutsideWrapper';


function App() {
  return (
    <div className="App">
      <div className="container">
        <OutsideWrapper/>

      </div>
    </div>
  );
}

export default App;
